import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-document-card',
  standalone: true,
  templateUrl: './document-card.component.html',
  styleUrl: './document-card.component.scss',
})
export class DocumentCardComponent {
  readonly title = input.required<string>();
  readonly pressed = output<void>();

  onPress(): void {
    this.pressed.emit();
  }
}
